import React, { useState } from "react";
import { Button, Card, CardHeader, Collapse, Table } from "reactstrap";
import { addDocumentos, ModalUploadDocs } from "../../sec/ModalUploadDocs";
import { useSelector } from "react-redux";
import moment from "moment";
import { has_role } from "../../util/General";
import { routes } from "../General";
import axios from "axios";
import { getDatosDoc } from "./utils";

function findTipo(tipo) {
    switch (tipo) {
        case "siniestrosGen":
            return "Siniestro Gen";
        case "siniestroVam":
            return "Siniestro Vam";
        case "poliza":
            return "Pólizas";
        case "vinculacion":
            return "Vinculación";
        default:
            return "-";
    }
}

export const DocsDigitalTabla = ({ docdigital, onClose, tipo, dato, ocultarAcordeon, ocultar, vinculacion }) => {
    const [open, setOpen] = useState(!!ocultarAcordeon);
    const [modulo, setModulo] = useState({ moduloDoc: false });
    const user = useSelector(state => state.user);
    let isAdmin = has_role(user, "ROLE_ADMIN") || has_role(user, "ROLE_EJECUTIVO");
    const estado = dato?.estado || "";

    const openCollapse = () => {
        setOpen(!open);
    };

    const showModuloDoc = open => {
        setModulo({ moduloDoc: open });
    };

    const datosDoc = getDatosDoc(tipo, dato);

    const deleteFile = id => {
        axios
            .get(routes.api + "/delete/doc", { params: { id: id, user: user.usuario } })
            .then(() => {
                // alert.current.show_info('eliminado'); pasar alert
                onClose();
            })
            .catch(error => {
                console.error("error", error);
            });
    };

    const eliminar = has_role(user, "ROLE_ADMIN") || has_role(user, "ROLE_EJECUTIVO");

    const isEmpty = (docdigital.minio || []).length + (docdigital.doc || []).length === 0;

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                {!ocultarAcordeon && (
                    <CardHeader role="tab" className={`${open && "active"}`}>
                        <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                            {vinculacion === true ? "Documentos Vinculación" : "Documentos Digitales"}
                            <i
                                className={
                                    !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                                }
                            />
                        </div>
                    </CardHeader>
                )}
                <Collapse isOpen={open}>
                    <Table className="adjusttd text-center detallex" responsive>
                        <thead className="text-primary">
                            <tr>
                                <th>Item</th>
                                <th>Fecha</th>
                                {isAdmin && (
                                    <>
                                        <th>Tipo</th>
                                        <th>Usuario</th>
                                    </>
                                )}
                                <th>Nombre del Archivo</th>
                                <th>URL</th>
                                {eliminar && <th>Eliminar</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {docdigital.minio?.map((docm, index) => (
                                <tr key={docm.id}>
                                    <td>{index + 1}</td>
                                    <td>{moment(docm.metadato?.fecha).local().format("DD/MM/YYYY")}</td>
                                    {isAdmin && (
                                        <>
                                            <td>{findTipo(docm.tipo)}</td>
                                            <td>{docm.metadato?.username}</td>
                                        </>
                                    )}
                                    <td>{docm.metadato?.dsc}</td>
                                    <td>
                                        <a className="font-weight-bold" href={docm.url} target="_blank" rel="noreferrer">
                                            Ver Documento
                                        </a>
                                    </td>
                                    {eliminar && (
                                        <td>
                                            <a
                                                className="fas fa-trash"
                                                onClick={() => {
                                                    window.confirm("Esta Seguro de Eliminar el archivo") &&
                                                        deleteFile(docm.cdArchivo);
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                            {docdigital.doc?.map((doc, index) => (
                                <tr key={doc.id}>
                                    <td>{index + 1}</td>
                                    <td>{doc.fc ? moment(doc.fc).local().format("DD/MM/YYYY") : "-"}</td>
                                    {isAdmin && (
                                        <>
                                            <td>{doc.tipo}</td>
                                            <td> -</td>
                                        </>
                                    )}
                                    <td> -</td>
                                    <td>
                                        <a
                                            className="font-weight-bold"
                                            href={routes.api + "/pdf/" + doc.code}
                                            target="_blank" rel="noreferrer"
                                        >
                                            Ver Documento
                                        </a>
                                    </td>
                                    <td />
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {isEmpty && (
                        <div className={"mt-3 mb-3"}>
                            <p>No existen documentos cargados.</p>
                        </div>
                    )}
                    {(has_role(user, "ROLE_ADMIN") ||
                        has_role(user, "ROLE_BROKER") ||
                        has_role(user, "ROLE_EJECUTIVO")) &&
                        !ocultar &&
                        estado !== "X" && (
                            <div className="text-right">
                                <Button color="yellow" className="mt-2" onClick={() => showModuloDoc(true)}>
                                    Subir Documentos
                                </Button>
                            </div>
                        )}
                    <ModalUploadDocs
                        open={modulo.moduloDoc}
                        toggleModal={showModuloDoc}
                        datos={datosDoc}
                        onClose={onClose}
                    />
                </Collapse>
            </Card>
        </div>
    );
};
